import React from "react";
import Header from "./Home/Header";
import Games from "./Home/GamesSection";
import Builds from "./Home/BuildSection";
import MarketSection from "./Home/MarketSection";
import EventSection from "./Home/EventSection";

function Home() {
  return (
    <>
      <Header isFull={0} />
      <Games />
      <Builds />
      <MarketSection
        sectionId="market"
        bgImage="./img/marketLayer.jpg"
        title="Market"
        subTitle="Everything in one place"
        text="In MetaAge, you can buy various items such as marketplace, land, clothing, real estate, and game items. MetaAge supports both solana blockchain base and provides fast and reliable digital art products."
      />
      <EventSection />
      <MarketSection
        sectionId="nft"
        bgImage="./img/nftLayer.jpg"
        title="NFT's"
        subTitle="Boost Your Status with NTFs"
        text="Get robots with incredible and different abilities. Incrase your power and get a change to earn more."
      />
    </>
  );
}

export default Home;
